<div class="card shadow-sm">
    <!-- Les images doivent être en 4:3 -->
    <img src="{{ article.pathImg }}" class="card-img-top ratio ratio-4x3" alt="photo article">
    <div class="card-body">
        <h3 class="card-title">{{ article.title }}</h3>
        <div class="card-text mb-2" [innerHtml]="article.intro | slice:0:100"></div>
        <button class="btn fs-5">Lire l'article</button>
    </div>
</div>
